export default {"src":"/_next/static/media/no-food.66716706.gif","height":500,"width":500,"blurWidth":0,"blurHeight":0};